/**
 * Local calendar day, never UTC: a session that starts at 00:10 belongs to
 * that morning, which is what both the muqri and the student mean by "today".
 */
export function dayKey(d: Date): string {
  const y = String(d.getFullYear());
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function sessionId(muqriId: string, d: Date): string {
  return `${muqriId}-${dayKey(d)}`;
}
